var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpdate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.44 18.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.07,8.78h-2.62c-.98,0-1.78-.79-1.78-1.78v-2.62c0-.26-.21-.47-.47-.47s-.47.21-.47.47v2.62c0,.98-.79,1.78-1.78,1.78h-2.62c-.26,0-.47.21-.47.47s.21.47.47.47h2.62c.98,0,1.78.79,1.78,1.78v2.62c0,.26.21.47.47.47s.47-.21.47-.47v-2.62c0-.98.79-1.78,1.78-1.78h2.62c.26,0,.47-.21.47-.47s-.21-.47-.47-.47Z",
    fill: "#4d4d4d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6,18.49H3.8C1.68,18.49-.04,16.76-.04,14.64V3.84C-.04,1.72,1.68,0,3.8,0h10.8c2.12,0,3.84,1.72,3.84,3.84v10.8c0,2.12-1.72,3.84-3.84,3.84ZM3.8,1.01C2.23,1.01.96,2.28.96,3.84v10.8c0,1.56,1.27,2.84,2.84,2.84h10.8c1.56,0,2.84-1.27,2.84-2.84V3.84c0-1.56-1.27-2.84-2.84-2.84H3.8Z",
    fill: "#4d4d4d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.9245ea4055bdbc5e8710b2941f834b12.svg";
export { ForwardRef as ReactComponent };